import React from "react";
import "./Footer.scss";
import { COPYV2 } from "../../../consts/CopyV2";

const QA_ID_PREFIX = `Footer`;

function Footer() {
  return (
    <div className="main-footer" data-testid={`${QA_ID_PREFIX}-container`}>
      <div data-testid={`${QA_ID_PREFIX}-copyright`}>
        {COPYV2.FOOTER.COPYRIGHT}
      </div>
    </div>
  );
}

export default Footer;
